var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userDataLoaded)?_c('div',[_c('router-view'),_c('ca-dialog'),_c('ca-confirm-dialog'),_c('security-form-dialog'),_c('snackbar')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }